import React from 'react';
import { Navigate } from 'react-router-dom';
import { useBetterAuthConvexAuth } from '../../hooks/useAppAuth';

/**
 * RoleBasedRoute component that redirects users based on their role.
 * Admins go to /admin, customers go to /dashboard.
 */
const RoleBasedRoute: React.FC = () => {
  const { isLoaded, isSignedIn, isLoadingProfile, isAdmin } = useBetterAuthConvexAuth();

  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/login" replace />;
  }

  if (isLoadingProfile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500 mb-4"></div>
          <p className="text-gray-600">Loading your profile...</p>
        </div>
      </div>
    );
  }

  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default RoleBasedRoute;
